import { SelectSheetOption } from "../../../components/MobileForm";
import {
  AdminActivityPageSize,
  AdminAuditAction,
  AdminAuditTargetType,
} from "../../../services";
import {
  ActivityActionGroup,
  ActivityFilterOption,
  ActivityPeriodFilter,
} from "./types";

export const ACTIVITY_SEARCH_MAX_LENGTH = 100;
export const ACTIVITY_SEARCH_DEBOUNCE_MS = 300;

export const ACTIVITY_PAGE_SIZES: AdminActivityPageSize[] = [10, 25, 50];
export const DEFAULT_ACTIVITY_PAGE_SIZE: AdminActivityPageSize = 25;
export const ACTIVITY_PAGE_SIZE_OPTIONS: SelectSheetOption[] =
  ACTIVITY_PAGE_SIZES.map((size) => ({
    value: String(size),
    label: String(size),
  }));
export const ACTIVITY_PAGE_SIZE_LABEL = "Rows per page";

export const ACTION_LABELS: Record<AdminAuditAction, string> = {
  TICKER_REQUEST_APPROVED: "Ticker request approved",
  TICKER_REQUEST_REJECTED: "Ticker request rejected",
  INSTRUMENT_CREATED: "Instrument created",
  INSTRUMENT_LISTING_REPAIRED: "Instrument listing repaired",
  INSTRUMENT_SOURCE_COUNTRY_SET: "Source country set",
  INSTRUMENT_PRICE_RECORDED: "Price recorded",
  CORPORATE_ACTION_RECORDED: "Corporate action recorded",
  CORPORATE_ACTION_DEFERRED: "Corporate action deferred",
  CORPORATE_ACTION_RESUMED: "Corporate action resumed",
  CORPORATE_ACTION_RECONCILED: "Corporate action reconciled",
  BACKFILL_JOB_RETRIED: "Backfill job retried",
  SNAPSHOT_JOB_RECALCULATED: "Snapshot job recalculated",
};

export const ACTION_GROUPS: ActivityActionGroup[] = [
  {
    label: "Ticker requests",
    actions: ["TICKER_REQUEST_APPROVED", "TICKER_REQUEST_REJECTED"],
  },
  {
    label: "Instruments",
    actions: [
      "INSTRUMENT_CREATED",
      "INSTRUMENT_LISTING_REPAIRED",
      "INSTRUMENT_SOURCE_COUNTRY_SET",
      "INSTRUMENT_PRICE_RECORDED",
    ],
  },
  {
    label: "Corporate actions",
    actions: [
      "CORPORATE_ACTION_RECORDED",
      "CORPORATE_ACTION_DEFERRED",
      "CORPORATE_ACTION_RESUMED",
      "CORPORATE_ACTION_RECONCILED",
    ],
  },
  {
    label: "Jobs",
    actions: ["BACKFILL_JOB_RETRIED", "SNAPSHOT_JOB_RECALCULATED"],
  },
];

export const PERIOD_OPTIONS: ActivityFilterOption<ActivityPeriodFilter>[] = [
  { value: "all", label: "All dates" },
  { value: "today", label: "Today" },
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
];

export const TARGET_TYPE_LABELS: Record<AdminAuditTargetType, string> = {
  TICKER_REQUEST: "Ticker request",
  INSTRUMENT: "Instrument",
  CORPORATE_ACTION: "Corporate action",
  BACKFILL_JOB: "Backfill job",
  SNAPSHOT_JOB: "Snapshot job",
};

export const FIELD_LABELS: Record<string, string> = {
  status: "Status",
  instrumentId: "Instrument ID",
  method: "Approval method",
  isInstrumentCreated: "Instrument created",
  reason: "Reason",
  newJobId: "New job ID",
  date: "Price date",
  type: "Type",
  effectiveMarketDate: "Effective date",
  newShares: "New shares",
  oldShares: "Old shares",
  successorInstrumentId: "Successor instrument ID",
  deferredAt: "Deferred at",
  deferredByUserId: "Deferred by user ID",
  reconciledByUserId: "Reconciled by user ID",
  symbol: "Symbol",
  exchange: "Exchange",
  name: "Name",
  assetType: "Asset type",
  nativeCurrency: "Currency",
  manualPricingOnly: "Manual pricing only",
  yahooSymbol: "Provider symbol",
  sourceCountry: "Source country",
  priceNative: "Price",
  fxToEur: "FX to EUR",
  priceEur: "Price (EUR)",
  source: "Source",
};
